<script>
  import { onMount } from 'svelte'
  import { language, formatI18nDate, t } from '../../i18n/i18n'
  import { userStore, locationStore, clientStore } from '../../state/store'
  import { getLocationData, getClientData } from '../../state/actions'
  import PageHeader from '../../components/PageHeader.svelte'
  import { isUserAdmin } from './../../helpers/utils'
  import Spinner from '../../components/Spinner.svelte'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import { request } from '../../helpers/api'
  import { getName } from '../../helpers/utils'
  import Datepicker from 'svelte-calendar'
  import { push } from 'svelte-spa-router'

  
  let dateFormat = '#{l}, #{F} #{j}, #{Y}'
  const minDate = new Date()
  minDate.setFullYear(minDate.getFullYear() -1)
  const maxDate = new Date()
  maxDate.setMonth(maxDate.getMonth() + 2)
  let reportData = []
  let today = new Date()
  let promise

  $: promise = getReportData(today)

  const getReportData = async () => {
    reportData = await request({
      url: `/api/reports/?tenant=${$userStore.tenant_id}&start=${today}&end=${today}`
    })
  }

  onMount(() => {
    promise = Promise.all([getLocationData(), getReportData(), getClientData()])
  })
</script>

<style>
  img {
    max-width: 12rem;
    height: auto;
  }
</style>

<ViewContainer>
  <PageHeader>
    <h1>{$t.daily_report}</h1>
    <Datepicker start={minDate} end={maxDate} format='{dateFormat}' bind:selected={today} />
  </PageHeader>
  {#await promise}
    <Spinner />
  {:then}
    <article class="g-card-list-wrapper">
      {#if reportData.length === 0}
        <div>
          <p>{$t.no_logs}</p>
        </div>
      {:else}
        {#each reportData as data}
          <ul on:click={() => push(`/locations/${data.location_id}`)} class="g-card-list">
            {#each Object.entries(data) as [key, val]}
              {#if key === 'client_id'}
                <li>
                  <p>{$t['Client Name']}</p>
                  <p>{getName($clientStore, val)}</p>
                </li>
              {/if}      
              {#if key === 'name'}
                <li>
                  <p>{key}</p>
                  <p>{val}</p>
                </li>
              {/if}      
              {#if key === 'location_id'}
                <li>
                  <p>{$t.address}</p>
                  <p>{$locationStore.find(location => location._id === val).address}</p>
                </li>
              {/if}      
              {#if key === 'time_stamp'}
                <li>
                  <p>{$t[key]}</p>
                  <p>{formatI18nDate($language, val)}</p>
                  <p>{new Date(val).toLocaleTimeString($language)}</p>
                </li>
              {/if}
              {#if key === 'signature' && isUserAdmin($userStore) }
                <li>
                  <p>{$t[key]}</p>
                  <img src={val} alt="signature">
                </li>
              {/if}
              {#if key === 'assignee' && isUserAdmin($userStore) }
                <li>
                  <p>{$t[key]}</p>
                  <p>{val}</p>
                </li>
              {/if}
              {#if key === 'note' && val.length > 0 }
                <li class="note">
                  <p>{$t['Notes']}</p>
                  <p>{val}</p>
                </li>
              {/if}
            {/each}
          </ul>
        {/each}
      {/if}
    </article>
  {/await}
</ViewContainer>
